import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'input',
    'field'
  ];

  initialize () {
    this.placeChanged = this.placeChanged.bind(this);
  }

  connect () {
    if (typeof window.google !== 'undefined') {
      this.initAutocomplete();
    }
  }

  initAutocomplete () {
    this.autocomplete = new window.google.maps.places.Autocomplete(this.inputTarget, {});
    this.autocomplete.addListener('place_changed', this.placeChanged);
  }

  placeChanged () {
    this.place = this.autocomplete.getPlace();

    const addressComponents = this.place.address_components;

    if (addressComponents) {
      const formattedAddress = this.formatAddress(addressComponents);

      this.fieldTargets.forEach((target) => {
        target.value = formattedAddress[target.dataset.addressAutocompleteType] || '';
      });
    }
  }

  preventSubmit (event) {
    if (event.code === 'Enter') {
      event.preventDefault();
    }
  }

  formatAddress (addressComponents) {
    const formatted = {};

    addressComponents.forEach((component) => {
      (component.types || []).forEach((type) => {
        if (type === 'country') {
          formatted[type] = component.short_name;
          return;
        }

        if (type === 'postal_town' && !formatted.locality) {
          formatted.locality = component.long_name;
          return;
        }

        formatted[type] = component.long_name;
      });
    });

    return formatted;
  }
}
